import { render, staticRenderFns } from "./dietGuidelines.vue?vue&type=template&id=070e409a&scoped=true&"
import script from "./dietGuidelines.vue?vue&type=script&lang=js&"
export * from "./dietGuidelines.vue?vue&type=script&lang=js&"
import style0 from "./dietGuidelines.vue?vue&type=style&index=0&id=070e409a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e409a",
  null
  
)

component.options.__file = "dietGuidelines.vue"
export default component.exports